import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import * as actions from 'store/actions';
import { faUser, faSignInAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SignUp from 'Flow2/components/AdvancedBox/AdvancedForm/SignUp/SignUp';
import * as cTypes from 'Flow2/components/AdvancedBox/AdvancedConfig/ConfigTypes';
import MessageService from 'Flow2/components/Services/MessageService/MessageService';
import "./SignIn.scss";

const SignIn = (props) => {
    const [userInputs, setUserInputs] = useState({});
    const [errors, setErrors] = useState({});
    const [isShow, setIsShow] = useState(false);
    const [data, setData] = useState(cTypes.SIGNIN_ITEMS);
    const [others, setOthers] = useState({});

    const fm = (id) => props.intl.formatMessage({ id });

    useEffect(() => {
        if (props.data) setData(props.data);
    }, [props.data, props.lg]);

    const handleSignIn = (e) => {
        e.preventDefault();
        let params = [];

        cTypes.SIGNIN_ITEMS.forEach((item) => {
            params.push(userInputs[item.name]);
        })
        if (params && params.some(p => !p)) {
            console.log("LOGS: handleSignIn Errors", errors)
        } else {
            props.onAuth(params[0], params[1], true, props.intl.formatMessage);
            props.onClose();
        }
    }

    const onInput = ({ e, item }) => {
        const { value } = e.target;
        let isValid = true;
        if (item.isRequired) {
            if (!value || !value.trim()) setErrors({ ...errors, [item.name]: true });
            else setErrors({ ...errors, [item.name]: false });
        }
        if (item && item.rules && props.checkValidity) {
            isValid = props.checkValidity(value, item.rules);
            if (!isValid) setErrors({ ...errors, [item.name]: true });
            else setErrors({ ...errors, [item.name]: false });
        }
        setUserInputs((prev) => {
            return ({ ...prev, [item.name]: value || '' });
        });
    }

    const getHeadline = () => {
        let txt = fm('login.signup');
        if (props.heading) txt = props.heading;
        return (
            <h1 className="signin-heading">
                <FontAwesomeIcon icon={faUser} />
                {txt}
            </h1>
        )
    }

    const getSubTxt = () => {
        if (props.subtxtItems) {
            return props.subtxtItems.map(item => {
                if (item.type == cTypes.BREAKLINE) return <div className="signin-breakline"></div>
                if (item.type === cTypes.LINK_BTN) {
                    return (
                        <div>
                            {fm(item.before)}
                            <span className="signin-blue"
                                onClick={item.isRegister ? onRegister : null}>
                                {fm(item.intl)}
                            </span>
                            {fm(item.after)}
                        </div>
                    )
                }
                return (<div>{fm(item.intl)}</div>)
            })
        }
        return null;
    }

    const onForgot = () => {
        MessageService.infoMsg({
            formatMessage: props.intl.formatMessage,
            titleIntl: "page.auth.link.forgot", textIntl: "page.auth.forgot.message"
        });
    }

    const onRegister = () => {
        setIsShow(true);
    }

    const showBottom = () => {
        let data = cTypes.SIGNIN_BOTTOM_ITEMS;
        if (props.bottomItems) data = props.bottomItems;
        return data.map((item, i) => {
            if (item.link) {
                return (
                    <div key={`signin${i}${item.name}`} className="signin-register-link">
                        {item.before && fm(item.before)}
                        <a href={item.link}>{item.after ? fm(item.after) : fm(item.intl)}</a>
                    </div>)
            }
            let onItemClick;
            if (item.isRegister) onItemClick = onRegister;
            if (item.isForgot) onItemClick = onForgot;
            return (
                <div key={`signin${i}${item.name}`} onClick={onItemClick}
                    className="signin-register-item">
                    {fm(item.intl)}
                </div>
            )
        })
    }

    const showForm = () => {
        return (
            <div className="signin-form-wrapper">
                <div className="signin-top">
                    {getHeadline()}
                    <div className="signin-subtxt">{getSubTxt()}</div>
                </div>
                <form className="signin-form" onSubmit={handleSignIn}>
                    {data.map((item, i) => (
                        <div className="signin-group" key={`signuppage-${i}${item.name}`}>
                            <label htmlFor={item.name} className="signin-label">
                                <img src={item.icon} />{fm(item.intl)}
                            </label>
                            <input className={`signin-input ${errors[item.name] ? ' signin-red' : ''}`}
                                type={item.type} value={userInputs[item.name]}
                                placeholder={item.placeholder ? item.placelholder : fm(item.intl)}
                                required={item.isRequired} id={item.name} onChange={(e) => onInput({ e, item })} />
                        </div>
                    ))}
                    <button className="signin-btn">
                        <FontAwesomeIcon icon={faSignInAlt} />{fm('app.login')}
                    </button>
                    <div className="signin-register">{showBottom()}</div>
                </form>
            </div>
        )
    }

    const showDefaultForm = () => {
        return (
            <div className="signin-wrapper">
                {showForm()}
            </div>
        )
    }

    const onCbChange = ({ e, item }) => {
        setOthers({ ...others, [`${item.name}`]: e.target.checked });
        if (e.target.checked) {
            setErrors({ ...errors, [`${item.name}`]: false });
        }
    }

    const showCheckBox = ({ item }) => {
        return (
            <div className={`signin-cb ${errors[item.name] ? 'signin-cb-required' : null}`}>
                <input type="checkbox" value={others[item.name]} onChange={(e) => onCbChange({ item, e })} />
                <label className={item.htmlClasses ? item.htmlClasses : null}>{fm(item.intl)}</label>
            </div>)
    }

    const showList = ({ item }) => {
        return (
            <ul>
                {item.data.map(li => (
                    <li className={li.htmlClasses ? li.htmlClasses : null}>
                        {li.type == cTypes.LINK ? (
                            <>
                                {li.before && <span>{fm(li.before)}</span>}
                                <a className="signin-link" href={`mailto:${li.link}`}>{li.link}</a>
                                {li.after && <span>{fm(li.after)}</span>}
                            </>
                        ) : fm(li.intl)}
                    </li>
                ))
                }
            </ul>
        )
    }

    const showLink = ({ item }) => {
        return (
            <div className="signin-linkbox">
                {item.before && <span>{fm(item.before)}</span>}
                <a className="signin-link" href={`mailto:${item.link}`}>{item.link}</a>
                {item.after && <span>{fm(item.after)}</span>}
                {item.link02 && (<a className="signin-link" href={`mailto:${item.link02}`}>{item.link02}</a>)}
            </div>
        )
    }

    const showText = ({ item }) => {
        return (
            <p>
                {item.before && (
                    <span className={item.beforeClasses ? item.beforeClasses : null}>{fm(item.before)}</span>
                )}
                <span className={item.htmlClasses ? item.htmlClasses : null}>{fm(item.intl)}</span>
                {item.after && (
                    <span className={item.afterClasses ? item.afterClasses : null}>{fm(item.after)}</span>
                )}
            </p>
        )
    }

    const showFormWithInfo = () => {
        return (
            <div className="signin-xl-wrapper">
                <div className="signin-left">
                    {props.infoItems.map(item => {
                        if (item.type === cTypes.CHECKBOX) return showCheckBox({ item });
                        if (item.type === cTypes.HEADLINE) return <h2>{fm(item.intl)}</h2>
                        if (item.type === cTypes.LIST) return showList({ item });
                        if (item.type === cTypes.LINK) return showLink({ item });
                        if (item.type == cTypes.BREAKLINE) return <div className="signin-breakline"></div>
                        return showText({ item });
                    })}
                </div>
                <div className="signin-right">
                    {showForm()}
                </div>
            </div>
        )
    }

    return (
        <>
            <div className="signin-hero-bg">
                <div className="signin-box">
                    {props.infoItems ? showFormWithInfo() : showDefaultForm()}
                </div>
            </div>
            {isShow && (
                <SignUp isOpened={isShow} heading={fm('auth.welcome')}
                    logo={props.logo} withLoginBtn={true} data={cTypes.SIGNUP_TDK_ITEMS}
                    subtxtItems={cTypes.SIGNUP_TDK_SUBTXT_ITEMS}
                    checkValidity={props.checkValidity}
                    onClose={() => setIsShow(false)} />)}
        </>
    )
}

const mapStateToProps = (state) => ({
    // authObjects: state.auth.authObjects,
});

const mapDispatchToProps = (dispatch) => ({
    onAuth: (user, password, isSignup, formatMessage) => dispatch(actions.auth(user, password, isSignup, formatMessage)),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(SignIn));
